import { render } from "./ShoppingIngredientListItem.vue?vue&type=template&id=53bafd9c&scoped=true&ts=true"
import script from "./ShoppingIngredientListItem.vue?vue&type=script&lang=ts"
export * from "./ShoppingIngredientListItem.vue?vue&type=script&lang=ts"

import "./ShoppingIngredientListItem.vue?vue&type=style&index=0&id=53bafd9c&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53bafd9c"]])

export default __exports__